import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaHealthCertificate = yup.object().shape({
  title: yup
    .string()
    .required(
      translate('modelsHealthCertificatesCreateEdit.validation.titleRequired'),
    ),
  text_description: yup.string(),
});
